import Icon from 'core/components/icons/Icon'
import { Dayjs } from 'utils/dayjs'

const MonthSwitcher = ({
  date,
  onChange
}: {
  date: Dayjs
  onChange: (date: Dayjs) => void
}) => {
  return (
    <div className="flex justify-center items-center gap-5 w-full">
      <Icon
        name="chevron-left"
        onClick={() => {
          onChange(date.subtract(1, 'month'))
        }}
        color="text-primary"
        width={20}
        height={20}
        className="hover:opacity-80 cursor-pointer select-none"
      />
      <p className="font-semibold w-24 text-center">
        {date.format('MMM YYYY')}
      </p>
      <Icon
        name="chevron-right"
        color="text-primary"
        width={20}
        height={20}
        className="hover:opacity-80 cursor-pointer select-none"
        onClick={() => {
          onChange(date.add(1, 'month'))
        }}
      />
    </div>
  )
}

export default MonthSwitcher
